import { useState } from "react";
import { ArrowRight, CheckCircle } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { Link } from "react-router-dom";
import { API } from "../App";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, source: "newsletter-block" });
      setSubscribed(true);
      setEmail("");
      toast.success("Successfully subscribed to our newsletter!");
    } catch (error) {
      toast.error("Failed to subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="newsletter" className="bg-white py-24 md:py-36" data-testid="newsletter-section" style={{ borderTop: "1px solid rgba(10,10,10,0.06)" }}>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl">
          <span className="editorial-overline mb-5 block">Newsletter</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-950 mb-5 tracking-tight leading-tight">
            Stay ahead of<br />the <em className="italic font-normal text-wine-700">conversation</em>.
          </h2>
          <p className="text-neutral-600 text-base mb-10 leading-relaxed">
            Get the latest stories on the people, brands, companies and initiatives shaping business and culture, delivered to your inbox.
          </p>

          {subscribed ? (
            <div className="flex items-center gap-3 text-green-700 animate-fade-in">
              <CheckCircle className="w-5 h-5" />
              <span className="text-base font-medium">Thank you for subscribing!</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="newsletter-underline-input"
                required
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="inline-flex items-center gap-2 text-neutral-950 text-sm font-semibold tracking-wider uppercase hover:text-wine-700 transition-colors disabled:opacity-50"
                data-testid="newsletter-submit-button"
              >
                {loading ? (
                  <div className="w-4 h-4 border-2 border-neutral-950 border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <>
                    Subscribe
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </form>
          )}

          <p className="text-neutral-500 text-xs mt-8">
            By subscribing, you agree to our <Link to="/privacy-policy" className="underline hover:text-neutral-950">Privacy Policy</Link>. Unsubscribe at any time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
